export default __webpack_public_path__ + "static/media/icaew_m.4e03a7ce.jpg";